'use strict';

// FundingCategory workspace — a classification for line-item funding. Overview-only (a LineItem→category childlist
// is deferred: it can be large and the LineItem display columns are not settled). NOTE: the Meadow collection is
// `FundingCategorys` (naive pluralization), not `FundingCategories`.
module.exports = {
	Identifier: 'FundingCategoryWorkspace', Ordinal: 251,
	Entity: { Name: 'FundingCategory', IDField: 'IDFundingCategory', Collection: 'FundingCategorys', GUIDField: 'GUIDFundingCategory' },
	Header: { Eyebrow: 'Funding Category', Title: (r) => r.Name || `Funding Category ${r.IDFundingCategory}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/FundingCategory/List' },
	Tabs: [ { Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } } ],
	FieldGroups: [ { Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'Code', Label: 'Code', Mono: true }, { Key: 'Type', Label: 'Type' }, { Key: 'Description', Label: 'Description', Wide: true } ] } ],
};
